import React, { useState } from 'react';
import SubmitRequest from './RefundRequest';
import RequestHistory from './RequestHistory';
import SearchProduct from '../Inventory/Product/searchProduct';
import ProductListingFilter from '../Inventory/Product/ProductListingFilter';
import { useDispatch, useSelector } from 'react-redux';

const Refunds = () => {
    const [activeTab, setActiveTab] = React.useState(1);
    const [showSearch, setShowSearch] = useState(false);
    const [searchTxt, setSearchTxt] = useState('');
    const [isSearch, setIsSearch] = useState(false);
    const [isReset, setIsReset] = useState(false);
    const [showFilter, setShowFilter] = React.useState(false);
    const [filterDataObj, setfilterDataObj] = React.useState({});
    const [filterAction, setFilterAction] = React.useState('');
    const [sellerList, setSellerList] = useState([]);
    const [allSellers, setAllSellers] = useState([]);

    const dispatch = useDispatch();

    const handleSearchFilter = () => {
        setIsSearch(true);
    };

    const handleReset = () => {
        setSearchTxt('');
        setShowSearch(false);
        setIsSearch(false);
        setIsReset(true);
    };

    const handleFilterApply = (action) => {
        setFilterAction('apply');
    };

    const handleFilterReset = () => {
        setFilterAction('reset');
        setShowFilter(false);
    };

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec">
                    <span>Refunds</span>
                    {activeTab === 2 && (
                        <div>
                            <button className="btn cus-seconday-bg-btn ml-2" onClick={() => setShowSearch(!showSearch)}>
                                <i className="fa fa-search" aria-hidden="true"></i>
                            </button>
                            <button className="btn cus-seconday-bg-btn ml-2" onClick={() => setShowFilter(!showFilter)}>Filter</button>
                        </div>
                    )}
                </div>
                <SearchProduct
                    showSearch={showSearch}
                    searchTxt={searchTxt}
                    setSearchTxt={(searchTxt) => {
                        setSearchTxt(searchTxt);
                        setIsReset(false);
                    }}
                    handleReset={handleReset}
                    handleSearchFilter={handleSearchFilter}
                    placeHolderText="Search by tracking number"
                />

                {showFilter && (
                    <ProductListingFilter
                        showFilter={showFilter}
                        dispatch={dispatch}
                        useSelector={useSelector}
                        filterData={filterDataObj}
                        setfilterData={setfilterDataObj}
                        fetchProductList={handleFilterApply}
                        handleReset={handleFilterReset}
                        type="refunds"
                        sellerList={sellerList}
                        setSellerList={setSellerList}
                        allSellers={allSellers}
                        setAllSellers={setAllSellers}

                    />
                )}
                <div className="container-fluid">
                    <div className="cus-page-content-sec displayFlexAndBetween">
                        <div className="cus-tab-heading-sec">
                            <div className="tabs">
                                <button
                                    className={`${activeTab === 1 ? "cus-tab-btn active" : "cus-tab-btn"
                                        }`}
                                    onClick={() => setActiveTab(1)}
                                >
                                    Submit Request
                                </button>

                                <button
                                    className={`${activeTab === 2 ? "cus-tab-btn active" : "cus-tab-btn"
                                        }`}
                                    onClick={() => { setActiveTab(2); }}
                                >
                                    Request History
                                </button>

                            </div>
                        </div>
                    </div>

                    <div className="main_content_table">
                        <div className="">
                            <div className='refundWrapper'>
                                {activeTab === 1 && (
                                    <SubmitRequest />
                                )}
                                {activeTab === 2 && (
                                    <RequestHistory
                                        isReset={isReset}
                                        setIsSearch={setIsSearch}
                                        isSearch={isSearch}
                                        searchTxt={searchTxt}
                                        filterAction={filterAction}
                                        setFilterAction={setFilterAction}
                                        filterDataObj={filterDataObj}
                                        setfilterDataObj={setfilterDataObj}
                                    />
                                )}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </main>
    );
}

export default Refunds;